module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile",
    class: _vm.profileClass
  }, [_c('div', {
    staticClass: "profile__header",
    on: {
      "click": _vm.toggleVisibility
    }
  }, [_c('div', {
    staticClass: "profile__header-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "profile__title"
  }, [_vm._v("Mijn profiel")]), _vm._v(" "), _c('div', {
    staticClass: "profile__toggle-btn",
    class: _vm.toggleBtnClass
  })]), _vm._v(" "), _c('div', {
    staticClass: "profile__result"
  }, [_c('p', {
    staticClass: "profile__result-row"
  }, [(_vm.userProfile.baan1 !== null) ? _c('span', {
    staticClass: "profile__description"
  }, [_vm._v("\n                " + _vm._s(_vm.formatJobName(_vm.userProfile.baan1)) + "\n                "), (_vm.userProfile.uren1 !== null) ? _c('span', [_vm._v(" Als hybride docent wil ik " + _vm._s(_vm.formatDagen(_vm.userProfile.uren1)) + " per week in\n                mijn huidige baan blijven werken.")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "profile__result-row"
  }, [(_vm.userProfile.baan2 !== null) ? _c('span', {
    staticClass: "profile__description"
  }, [_vm._v("\n                Mijn huidige baan wil ik combineren " + _vm._s(_vm.formatJobName(_vm.userProfile.baan2)) + ".\n                "), (_vm.userProfile.uren2) ? _c('span', [_vm._v("Dit werk wil ik " + _vm._s(_vm.formatDagen(_vm.userProfile.uren2)) + " per week doen.")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.userProfile.onderwijsniveau) ? _c('p', {
    staticClass: "profile__result-row"
  }, [_vm._v("\n            Ik wil lesgeven in het " + _vm._s(_vm.userProfile.onderwijsniveau.toLowerCase()) + ".\n            "), (_vm.userProfile.vak2 !== null) ? _c('span', [_vm._v("Ik wil graag het vak " + _vm._s(_vm.userProfile.vak2.vak) + " doceren.")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.userProfile.baan1 && _vm.userProfile.baan1.isTeacher === false) ? _c('p', {
    staticClass: "profile__result-row"
  }, [(_vm.userProfile.bevoegdheid === false) ? _c('span', [_vm._v("Ik heb geen lesbevoegdheid.")]) : _vm._e(), _vm._v(" "), (_vm.userProfile.bevoegdheid === true) ? _c('span', [_vm._v("Ik heb een lesbevoegdheid.")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.userProfile.hasSubmitted) ? _c('p', [_vm._v("Ik heb dit plan verstuurd!")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40b4c714","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/profile.vue
// module id = 140
// module chunks = 0